import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  MatButtonModule,
  MatFormFieldModule,
  MatIconModule,
  MatInputModule,
  MatListModule,
  MatRippleModule
} from '@angular/material';

import { InputImagesComponent } from './input-images.component';

@NgModule({
  declarations: [InputImagesComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatListModule,
    MatIconModule,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    MatRippleModule
  ],
  providers: [],
  exports: [
    InputImagesComponent
  ]
})
export class InputImagesModule {
}
